import { h } from 'preact';

import SelectableSection from 'components/editor/selectableSection';
import AboutEditor from 'components/editor/pages/about/about';
import SimpleField from 'components/editor/settings/simpleField';
import MediaField from 'components/editor/settings/mediaField';

import s from 'components/editor/pages/about/aboutFocus.sss';

export default class FocusAboutEditor extends AboutEditor {
	s = s;

	renderVisualHero() {
		const content = this.props.content;
		return (
			<SelectableSection {...this.props} section="/hero" class={this.s.asset}>
				{!!content?.hero?.video && (
					<video
						autoplay
						loop
						muted
						playsinline
						src={content.hero.video}
						poster={content.hero.poster}
					/>
				)}
			</SelectableSection>
		);
	}

	renderVisualTagline() {
		const content = this.props.content;
		return (
			<SelectableSection {...this.props} section="/tagline" class={this.s.tagline}>
				{content?.tagline}
			</SelectableSection>
		);
	}

	renderVisualParts() {
		return [
			this.renderVisualHeader(),
			this.renderVisualHero(),
			this.renderVisualTagline(),
			this.renderVisualContent()
		];
	}

	renderHeroSettings() {
		return (
			<MediaField
				{...this.props}
				video
				label="Hero video"
				path={`${this.props.dataRoot}/content/hero/video`}
				group={this.props.config?.id}
				assetData={{ type: 'About Page Video', aspectRatio: '16:9', recommendedDimensions: '1920:1080' }}
			/>
		);
	}

	renderTaglineSettings() {
		return <SimpleField multiline rows={2} label="Header text" {...this.props} path={`${this.props.dataRoot}/content/tagline`} />;
	}

	allSettingsOptions() {
		return [
			{ label: 'Hero', path: '/hero' },
			{ label: 'Header text', path: '/tagline' },
			{ label: 'Content', path: '/content' },
		];
	}

	getActiveSettings() {
		if (this.props.activeElement === '/tagline') {
			return {
				nav: { label: 'Header text', path: '/tagline' },
				content: this.renderTaglineSettings(),
			};
		}
		return super.getActiveSettings();
	}
}